// extracted by mini-css-extract-plugin
var _1 = "TDAd1";
export { _1 as "base" }
